<template>
	<div class="wrapper">
		<div class="load">
			<cube-loading v-if="isShowHint"></cube-loading>
			<div>{{hint}}</div>
		</div>
	</div>
</template>

<script>
    import {mapMutations, mapGetters} from "vuex";

    export default {
        data() {
            return {
                // 车牌号码
                plateNumber: null,
                // 金额
                amount: 0.0,
                // 停车场名字
                plateName: "xx停车场",
                // 提示信息
                hint: "处理中",
                // 是否显示loading圈
                isShowHint: true,
                // 停车场信息
                parkinglotInfo: {},
                // 进出记录Id
                parkRecId: "",
                // 订单号
                orderInfo: "",
                // 定时器
                timer: null,
            };
        },
        computed: {
            ...mapGetters(["parkinglotId", "doorId", "areaId", "interfaceManner","userOpenid","buyId"])
        },
        mounted() {
            if (this.$route.params.parkinglotId && this.$route.params.doorId &&
				(localStorage.getItem('userOpenId') || this.userOpenid || localStorage.getItem('userBuyId') || this.buyId)) {
                this.parkingId = this.$route.params.parkinglotId;
                let doorId = this.$route.params.doorId;
                this.setParkinglotId(this.parkingId);
                this.setDoorId(doorId);
                this.$api.area.getAreaIdByDoorId(this.doorId).then(res => {
                    if (res.data.code == 200) {
                        this.setAreaId(res.data.data.id);
                        this.getNoPlateManual(this.checkBrowser.id)
                    }
                });

            }
        },
        methods: {
            getNoPlateManual (browserId) {
                let isOpenId, userOpenid, buyId;
                if (browserId == 13){
                    isOpenId = true;
                    buyId = null;
                    userOpenid = localStorage.getItem('userOpenId')||this.userOpenid ;
				} else if (browserId == 12){
                    isOpenId = false;
                    buyId = this.buyId || localStorage.getItem('userBuyId');
                    userOpenid = null;
				}
                this.$api.parkinglot.noPlateManual(
                    this.parkinglotId,
                    false,
                    this.doorId,
                    1,
                    isOpenId,
                    userOpenid,
                    buyId,
                    this.areaId,
                    this.interfaceManner
                ).then(res => {
                    if (res.data.code != 200) {
                        this.$createDialog({
                            type: "alert",
                            title: "提示",
                            content: res.data.msg||"未查询车辆出场",
                            icon: "cubeic-alert"
                        }).show();
                        this.hint = "未查询车辆出场";
                        this.isShowHint = false;
                    } else {
                        if (res.data.msg.indexOf("开闸成功") != -1) {
                            this.$createDialog({
                                type: "alert",
                                title: "提示",
                                content: res.data.msg,
                                icon: "cubeic-alert"
                            }).show();
                            this.hint = "开闸成功";
                            this.isShowHint = false;
                        } else {
                            this.timer = setInterval(() => {
                                if (this.plateNumber) {
                                    clearInterval(this.timer);
                                } else {
                                    this.getParkinglotInfo();
                                }
                            }, 1000);
                        }
                    }
                });
			},
            showConfirm() {
                this.$createDialog({
                    type: "confirm",
                    icon: "cubeic-location",
                    title: this.plateName,
                    content:
                        "&nbsp;&nbsp;&nbsp;&nbsp;无牌车车主您好，您需要缴费" +
                        this.amount +
                        "元",
                    confirmBtn: {
                        text: "去缴费",
                        active: true,
                        disabled: false,
                        href: "javascript:;"
                    },
                    cancelBtn: {
                        text: "取消",
                        active: false,
                        disabled: false,
                        href: "javascript:;"
                    },
                    onConfirm: () => {
                        if (this.parkRecId) {
                            this.$api.order
                                .order({
                                    outDoor: this.doorId,
                                    totalPrice: parseFloat(this.amount).toFixed(2),
                                    parkRec: this.parkRecId,
                                    parkinglotId: this.parkinglotId,
                                    goodsType: 2,
                                    closed: 0,
                                    paymentPlatform: this.checkBrowser.id,
                                    areaId: this.areaId
                                })
                                .then(res => {
                                    // alert(res.data.msg);
                                    if (res.data.code == 200) {
                                        this.orderInfo = res.data.data;
                                        let orderSnList = {
                                            0:this.orderInfo.orderSn
										};
                                        this.setOrderSnList(orderSnList);
                                        this.setOrderInfo(this.orderInfo);
                                        this.$router.push({name: "Order",params: {isEntry: true}});
                                    } else {
                                        this.$createDialog({
                                            type: "alert",
                                            title: "提示",
                                            content: "下单失败",
                                            icon: "cubeic-alert"
                                        }).show();
                                    }
                                });
                        } else {
                            // 当前记录无ID
                        }
                    },
                    onCancel: () => {
                        this.$createToast({
                            type: "warn",
                            time: 3000,
                            txt: "您取消了缴费"
                        }).show();
                        this.hint = "您取消了缴费，请重新扫码";
                        this.isShowHint = false;
                    }
                }).show();
            },
            getParkinglotInfo() {
                
                if (this.parkinglotId && this.doorId) {
                    this.$api.parkinglot.getParkinglotInfo(this.parkinglotId).then(res => {
                            console.log(res,'获取无牌车');
                            if (res.data.code == 200 && res.data.data) {
                                this.parkinglotInfo = res.data.data;
                                this.plateName = res.data.data.parkName;
                                console.log(this.parkinglotInfo);
                            }
                            return this.$api.parkinglot.getOutdoorRecord(this.doorId);
                        }).then(res => {
                            console.log(res.data.data);
                            if (res.data.code == 200 && res.data.data) {
                                this.plateNumber = res.data.data.plateno;
                                this.amount = parseFloat(res.data.data.allmoney).toFixed(2);
                                this.parkRecId = res.data.data.id;
                                this.setParkrec(res.data.data);
                                this.setParkinglotId(this.parkinglotId);
                                this.showConfirm();
                            }
                        });
                } else {
                    // 提示传递参数错误
                    this.$createDialog({
                        type: "alert",
                        title: "提示",
                        content: "二维码错误",
                        icon: "cubeic-alert"
                    }).show();
                }
            },
            ...mapMutations({
                setOpenId: "SET_OPENID",
                setBuyId: "SET_BUYID",
                setOrderInfo: "SET_ORDER_INFO",
                setParkinglotId: "SET_PARKINGLOTID",
                setDoorId: "SET_DOORID",
                setParkrec: "SET_PARKREC",
                setAreaId: "SET_AREA_ID",
                setOrderSnList: "SET_ORDERSNLIST"
            })
        },
        components: {}
    };
</script>

<style lang="stylus" scoped>
	@import '~common/stylus/variable';
	@import '~common/stylus/mixin';

	.wrapper {
		position: relative;
		width: 100%;
		height: 100%;
		background: #ffffff;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		.load {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-bottom: 36px;

			div {
				margin-top: 24px;
			}
		}
	}
</style>
